import { CUSTOM_TEMPLATE, NO_TEMPLATE } from '../_templates/Constants'
import { TEMPLATES_AVAILABLE } from '../_templates/Templates'
import { usePdfOptionsFormActions } from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'

const useHandleChangeTamplate = () => {
  const { mergeChanges } = usePdfOptionsFormActions()

  return value => {
    if (value === NO_TEMPLATE) {
      mergeChanges({
        template: value,
        svgTemplate: undefined,
        Component: undefined,
        customLogo: undefined
      })

      return
    }

    if (value === CUSTOM_TEMPLATE) {
      mergeChanges({
        template: value,
        Component: undefined,
        customLogo: undefined,
        svgTemplate: undefined
      })
      return
    }

    mergeChanges({
      template: value,
      customLogo: undefined,
      ...TEMPLATES_AVAILABLE[value]
    })
    return
  }
}
export default useHandleChangeTamplate
